import React from "react";
import { AnswerBox, Text, Wrapper } from "./style";

const ShortText = () => {
  return (
    <Wrapper>
      <AnswerBox>
        <Text>Type your answer</Text>
      </AnswerBox>
    </Wrapper>
  );
};

export default ShortText;
